export default {
  init() {
    // JavaScript to be fired on all pages

    $('.products .product_cat-pick-up-only .card .woocommerce-LoopProduct-link').prepend('<span class="pickup onsale">This item is pick up only</span>');

    // $('.modal-body .create').hide();
    // $('.modal-body .forgot').hide();
    //
    // $('#choice input[type="radio"]').click(function(){
    //   var inputValue = $(this).attr('value');
    //   var targetBox = $('.' + inputValue);
    //   $('.modal-body .body').not(targetBox).hide();
    //   $(targetBox).show();
    // });
    //
    // $('.modal-body #reset').click(function() {
    //   $('.modal-body .signin').hide();
    //   $('.modal-body .create').hide();
    //   $('.modal-body .forgot').show();
    // });
    //
    // $('.top-cart.not-empty').on('click', function() {
    //   event.preventDefault();
    //   $('.cart-dropdown').toggleClass('show');
    //   $('.cart-backdrop').toggleClass('show');
    // });
    //
    // $('.cart-backdrop').on('click', function() {
    //   $('.cart-dropdown').removeClass('show');
    //   $('.cart-backdrop').removeClass('show');
    // });

    // $('.navbar-toggler').click(function() {
    //   $(this).toggleClass('toggle-open');
    //   $('body').toggleClass('noscroll');
    //   $('header').toggleClass('header-open');
    //   $('body .mobile-backdrop').toggleClass('show');
    // });

    // $('#back').on('click', function() {
    //   $('.dropdown-menu').removeClass('show');
    // });

    // $('.dropdown .dropdown-toggle').on('click', function() {
    //   $('body .mobile-backdrop').toggleClass('show');
    //   $('body').toggleClass('noscroll');
    // });



    // --- WooCommerce cart indicator: toggle header class when cart changes (AJAX add/remove) ---
    // Uses WooCommerce's 'woocommerce_items_in_cart' cookie which reflects item count.
    const $cartLi = () => jQuery('ul.navbar-nav .icon-cart').closest('li.nav-item');

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }

    function cartHasItems() {
      const c = getCookie('woocommerce_items_in_cart');
      if (!c) return false;
      const n = parseInt(c, 10);
      return Number.isFinite(n) && n > 0;
    }

    function updateCartIndicator() {
      const $li = $cartLi();
      if (!$li.length) return;
      if (cartHasItems()) {
        $li.addClass('cart-has-items');
      } else {
        $li.removeClass('cart-has-items');
      }
    }

    // Initial state on page load
    updateCartIndicator();

    // Listen to WooCommerce events that indicate cart updates or fragment refreshes
    jQuery(document.body).on(
      'added_to_cart removed_from_cart wc_fragments_loaded wc_fragments_refreshed updated_wc_div updated_cart_totals',
      function () {
        // Defer slightly to allow cookies/fragments to update
        setTimeout(updateCartIndicator, 20);
      }
    );
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    console.log('just one more');


    function setuppagination() {
      var more = $('.page-numbers.next').attr('href');
      console.log(more);
      if( !more )
        return;

      $('.page-numbers').hide();
      justonemore(more);

      $(window).scroll(function () {
        var more = $('ul.products').data('next');
        if( more && more !== 'undefined' ) {
          var $pagination = $('nav.woocommerce-pagination');
          if ($pagination.length) {
            var hT = $pagination.offset().top,
                hH = $pagination.outerHeight(),
                wH = $(window).height(),
                wS = $(this).scrollTop();
            if (wS > (hT + hH - wH)) {
              justonemore(more);
            }
          }
        }
      });
    }

    function justonemore( url ) {
      if (!url || url === 'undefined') {
        return;
      }

      var skip = $('ul.products').data('skip');

      if( !skip ) {
        $('ul.products').data('skip', true);

        const loaderUrl = (window.themeLoadingIconUrl && typeof window.themeLoadingIconUrl === 'string' && window.themeLoadingIconUrl.length)
          ? window.themeLoadingIconUrl
          : '/wp-content/themes/13thwinery-2026/resources/assets/images/Rotatingrings.gif';
        $('section.winery_shop').append('<div id="shopspinner" class="d-flex flex-row"><img class="mx-auto my-3" src="' + loaderUrl + '" alt="loading..." /></div>');
        $.ajax({
          url: url,
          method: 'GET',
          success: function (response) {

            // before adding the result to our products grid, remove the hidden nav that is currently there so that
            // all logic is driven off the "last" result
            $('ul.products .woocommerce-pagination').remove();

            // add products
            $('ul.products').append($(response).find('ul.products').html());
            // get new pagination link
            var nextUrl = $(response).find('a.next.page-numbers').attr('href');
            $('ul.products').data('next', nextUrl || null);

            // set new trigger for next page
            $('ul.products').data('skip', false);

            $('#shopspinner').remove();
          },
        });
      }
    }



    setuppagination();

    $(window).on('wcpf_after_ajax_filtering', setuppagination);


    $('a.magnific-popup-link').magnificPopup({
      type: 'iframe',
      midClick: true,
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js